export default "__VITE_ASSET__CM5VUeGu__"